import api from "./api";

class UsuarioAPI {


  async login(headers, params) {
    const response = await api({
      method: 'post',
      url: '/login',
      headers,
      data: params
    });
    return response;
  }

  async updatePass(headers, params) {
    const response = await api({
      method: 'post',
      url: '/updatePass',
      headers,
      data: params
    });
    return response;
  }

  async getAcessos(headers) {

    const response = await api.get("/getAcessos", { headers });
    return response;
  }


  async getUsuarios(headers, params) {

    const response = await api.get("/getUsuarios", { headers, params });
    return response;
  }

  async getPerfis(headers, params) {

    const response = await api.get("/getPerfis", { headers, params });
    return response;
  }

  async salvar(headers, params) {
    const response = await api({
      method: 'post',
      url: '/addUsuario',
      headers,
      data: params
    });
    return response;
  }


  async deletar(headers, params) {
    const response = await api({
      method: 'delete',
      url: '/delUsuario',
      headers,
      data: params
    });
    return response;
  }


  async resetPassword(headers, params) {
    const response = await api({
      method: 'put',
      url: '/resetar_senha',
      headers,
      data: params
    });
    return response;
  }

}

export default new UsuarioAPI();
